import gql from 'graphql-tag';

export const placeCameraAdd = gql`
  mutation placeCameraAdd(
    $placeId: ID!
    $condominiumId: ID!
    $input: PlaceCameraLinkInput!
  ) {
    placeCameraAdd(
      placeId: $placeId
      condominiumId: $condominiumId
      input: $input
    )
  }
`;

export const placeCamerasSync = gql`
  mutation placeCamerasSync(
    $placeId: ID!
    $condominiumId: ID!
    $input: [PlaceCameraLinkInput!]!
  ) {
    placeCamerasSync(
      placeId: $placeId
      condominiumId: $condominiumId
      input: $input
    )
  }
`;

export const placeCameraRemove = gql`
  mutation placeCameraRemove(
    $placeId: ID!
    $condominiumId: ID!
    $cameraId: Int!
  ) {
    placeCameraRemove(
      placeId: $placeId
      condominiumId: $condominiumId
      cameraId: $cameraId
    )
  }
`;

export const cameraRename = gql`
  mutation cameraRename($condominiumId: ID!, $cameraId: Int!, $name: String!) {
    cameraRename(
      condominiumId: $condominiumId
      cameraId: $cameraId
      name: $name
    )
  }
`;
